import axiosInstance from '../utils/axiosInstance';
import type {
  Task,
  CreateTaskInput,
  UpdateTaskInput,
} from '../../types/task';

interface TaskResponse {
  success: boolean;
  data: { task: Task };
}

interface CreateTaskResponse {
  success: boolean;
  data: { task: Task; sentNow?: boolean };
}

export interface CreateTaskResult {
  task: Task;
  sentNow: boolean;
}

interface TasksResponse {
  success: boolean;
  data: { tasks: Task[] };
}

interface MutateResponse {
  success: boolean;
  data: { deleted?: boolean | number };
}

export const createTask = async (
  matterId: string,
  input: CreateTaskInput,
): Promise<CreateTaskResult> => {
  const res = await axiosInstance.post<CreateTaskResponse>(
    `/matters/${matterId}/tasks`,
    input,
  );
  return {
    task: res.data.data.task,
    sentNow: res.data.data.sentNow === true,
  };
};

export const listTasksForMatter = async (matterId: string): Promise<Task[]> => {
  const res = await axiosInstance.get<TasksResponse>(`/matters/${matterId}/tasks`);
  return res.data.data.tasks;
};

export const listTasks = async (
  status?: 'pending' | 'overdue' | 'completed',
): Promise<Task[]> => {
  const res = await axiosInstance.get<TasksResponse>(
    '/tasks',
    status ? { params: { status } } : undefined,
  );
  return res.data.data.tasks;
};

export const updateTask = async (
  matterId: string,
  taskId: string,
  updates: UpdateTaskInput,
): Promise<Task> => {
  const res = await axiosInstance.patch<TaskResponse>(
    `/matters/${matterId}/tasks/${taskId}`,
    updates,
  );
  return res.data.data.task;
};

export const deleteTask = async (
  matterId: string,
  taskId: string,
): Promise<void> => {
  await axiosInstance.delete<MutateResponse>(
    `/matters/${matterId}/tasks/${taskId}`,
  );
};

export const deleteCompletedTasks = async (): Promise<number> => {
  const res = await axiosInstance.delete<MutateResponse>('/tasks/completed');
  const deleted = res.data.data.deleted;
  return typeof deleted === 'number' ? deleted : 0;
};
